import {Component, OnInit, inject} from '@angular/core';
import {CompaniesService} from '../../_services/data/companies.service';
import {Company} from '../../_data/admin/company';
import {BehaviorSubject} from 'rxjs';
import {I18nService} from '../../_services/gui/i18n.service';
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';
import {containsIgnoreCase, reformatDate} from '../../_utils/lang';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {GuiPermissionsService} from '../../_services/gui/gui-permissions.service';
import {ItemListComponent} from '../common/item-list/item-list.component';
import {SortableDirective} from '../../_directives/sortable.directive';
import {RouterLink} from '@angular/router';
import {IconButtonComponent} from '../../common/icon-button/icon-button.component';
import {AsyncPipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-companies-admin',
    templateUrl: './companies-admin.component.html',
    styleUrls: ['./companies-admin.component.scss'],
    imports: [ItemListComponent, SortableDirective, RouterLink, IconButtonComponent, AsyncPipe, TranslateModule]
})
export class CompaniesAdminComponent implements OnInit {
  companiesService = inject(CompaniesService);
  guiPermissionsService = inject(GuiPermissionsService);

  faTrash = faTrash as IconProp;
  faEdit = faEdit as IconProp;

  reformatDate = reformatDate;

  companiesSubject: BehaviorSubject<Company[]> = new BehaviorSubject([]);
  filteredSortedCompanies: Company[];

  private i18nService = inject(I18nService);

  ngOnInit() {
    this.i18nService.setTitle('title.admin.companies.list');
  }

  onFilterSortUpdate(companies: Company[]) {
    this.filteredSortedCompanies = companies;
  }

  public companyMatchesFilter(filter: string, c: Company) {
    return containsIgnoreCase(c.companyName, filter);
  }

  delete(company: Company, ariaLabelledBy: string, container: HTMLElement) {
    this.companiesService.confirmDeleteCompany(company, ariaLabelledBy, container, (httpResponse) => {
      if(httpResponse.status === 200) {
        this.companiesSubject.next(this.companiesSubject.getValue().filter(value => value.companyName !== company.companyName));
      }
    });
  }

  searchForCompany(searchTerm: string): void {
    this.companiesService.searchForCompany(searchTerm).subscribe((c: Company[]) => this.companiesSubject.next(c));
  }

}
